import type { Dispatch } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { getCurrentMagentoClient } from "@jti/magento";

import type { MagentoOrderCreationIssueException } from "../../../../types/OrderExceptions.types";
import { OrderExceptionCode } from "../../../../types/OrderExceptions.types";
import { fetchCartPrices, fetchTrialCartPrices } from "../fetchCartPrices";

type SetShippingMethodType = { cartId: string; carrierCode: string; methodCode: string };

const handleMagentoOrderCreationIssue = (dispatch: Dispatch) => {
  const payload: MagentoOrderCreationIssueException = {
    code: OrderExceptionCode.MagentoOrderCreationIssue,
  };

  dispatch({
    type: "checkout/showError",
    payload,
  });
};

const setShippingMethodsOnCartThunk = (isFreeTrial: boolean) =>
  createAsyncThunk(
    isFreeTrial ? "freeTrialCart/setShippingMethodsOnCart" : "cart/setShippingMethodsOnCart",
    async ({ cartId, carrierCode, methodCode }: SetShippingMethodType, { dispatch }) => {
      const magentoApiClient = getCurrentMagentoClient(isFreeTrial);

      try {
        const response = await magentoApiClient.setShippingMethodsOnCart(cartId, carrierCode, methodCode);

        if (isFreeTrial) {
          dispatch(fetchTrialCartPrices(cartId));
        } else {
          dispatch(fetchCartPrices(cartId));
        }

        return response;
      } catch {
        handleMagentoOrderCreationIssue(dispatch);
      }
    }
  );

export const setShippingMethodsOnCart = setShippingMethodsOnCartThunk(false);
export const setFreeTrialShippingMethodsOnCart = setShippingMethodsOnCartThunk(true);
